<template>
  <div id="section-to-print" ref="pdfContent">
    <div class="row">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <table class="table add-page-break-after" v-if="rows">
                <thead>
                  <tr>
                    <th>no</th>
                    <th>nama</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in rows"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <td>{{ item.id }}</td>
                    <td>{{ item.nama }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table" v-if="rows">
                <thead>
                  <tr>
                    <th>no</th>
                    <th>nama</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in rows"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <td>{{ item.id }}</td>
                    <td>{{ item.nama }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12  -->
    </div>

    <!-- /row  -->
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
.add-page-break-before {
  page-break-before: always;
}
.add-page-break-after {
  page-break-after: always;
}
@media print {
  table {
    page-break-inside: avoid;
  }
  tr {
    break-inside: avoid;
  }
  tbody {
    display: block;
  }
}
</style>
<script>
export default {
  // Component logic goes here
  data() {
    return {
      rows: [
        { id: 1, nama: "value1" },
        { id: 2, nama: "desiredValue" },
        { id: 3, nama: "value3" },
        { id: 4, nama: "value4" },
        { id: 5, nama: "value5" },
        { id: 6, nama: "value6" },
        { id: 7, nama: "value7" },
        { id: 8, nama: "value8" },
        { id: 9, nama: "value9" },
        { id: 10, nama: "value10" },
        { id: 11, nama: "value11" },
        { id: 12, nama: "value12" },
        { id: 13, nama: "value13" },
        { id: 14, nama: "value14" },
        { id: 15, nama: "value15" },
        { id: 16, nama: "value16" },
        { id: 17, nama: "value17" },
        { id: 18, nama: "value18" },
        { id: 19, nama: "value19" },
        { id: 20, nama: "value20" },
        { id: 21, nama: "value21" },
        { id: 22, nama: "value22" },
        { id: 23, nama: "value23" },
      ],
    };
  },
  async mounted() {},
  methods: {
    getPageBreakStyle(index) {
      var rowSaatIni = index + 1;
      if (rowSaatIni === 7) return "add-page-break-after"; //page break di tr ke 7
      //1,2,3,4,5,6,7
      //8 9 10 11 12 13 14 15  [8 tr]
      //16 17 18 19 20 21 22 23 [8tr]
      //24 25 26 27 28 29 30 31 [8tr]

      if (rowSaatIni % 8 === 0) return "add-page-break-before";
      // return {
      //   "page-break-before": "always",
      // };

      console.log("getPageBreakStyle", index);
    },
  },
};
</script>
